/**
 * Shared constants for the chunk system.
 * Single source of truth for CEFR levels, chunk types, and Lens UI styling.
 */

export const CEFR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

export const CHUNK_CATEGORIES = ['vocabulary', 'phrasal_verb', 'collocation', 'idiom', 'grammar', 'knowledge', 'tone'];

/** Language-specific category subsets for UI display (settings pills, filters). */
const CJK_LANGS = new Set(['zh', 'ja', 'ko']);
const LATIN_CATS = ['vocabulary', 'phrasal_verb', 'collocation', 'idiom', 'grammar', 'knowledge'];
const CJK_CATS = ['vocabulary', 'collocation', 'idiom', 'grammar', 'tone', 'knowledge'];

/** Return the categories relevant to a book's language. Falls back to full list if language unknown. */
export function getCategoriesForLanguage(lang) {
  if (!lang) return CHUNK_CATEGORIES;
  return CJK_LANGS.has(lang) ? CJK_CATS : LATIN_CATS;
}

/** Categories that bypass adaptive level filtering — always shown regardless of user level. */
export const ALWAYS_SHOW_CATEGORIES = ['knowledge', 'idiom'];

export const DEFAULT_LEVEL_INTERACTIONS = Object.fromEntries(CEFR_LEVELS.map(l => [l, 0]));
export const DEFAULT_CATEGORY_INTERACTIONS = Object.fromEntries(CHUNK_CATEGORIES.map(c => [c, 0]));

export const LENS_FONT_FAMILY = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

/**
 * Derive Lens theme colors from isDarkMode flag.
 */
export function getLensTheme(isDarkMode) {
  return isDarkMode ? {
    bg: 'rgba(28, 28, 30, 0.97)',
    text: '#e5e5e7',
    muted: 'rgba(255,255,255,0.45)',
    border: 'rgba(255,255,255,0.06)',
    handleBar: 'rgba(255,255,255,0.2)',
  } : {
    bg: 'rgba(255, 255, 255, 0.97)',
    text: '#1a1a1a',
    muted: 'rgba(0,0,0,0.4)',
    border: 'rgba(0,0,0,0.06)',
    handleBar: 'rgba(0,0,0,0.15)',
  };
}
